import { defineStore } from "pinia";
import { useCurrentStore } from "@/stores/current";

export const useSubtitlesStore = defineStore("subtitles", {
  state: () => ({
    activeChannels: [],
    partialSubtitles: "",
    finalSubtitles: [],
    received: false,
  }),
  actions: {
    reset() {
      this.partialSubtitles = "";
      this.finalSubtitles = [];
      this.received = false;
    },
    setSubtitles({ channelId, text, type }) {
      type = type || "final";
      if (!this.activeChannels.includes(channelId)) this.activeChannels.push(channelId);
      if (useCurrentStore().getChannel?.id !== channelId) return;
      if (!text) return;
      if (type === "partial") this.partialSubtitles = text;
      else if (type === "final") {
        this.finalSubtitles.push(text);
        this.partialSubtitles = "";
      }
      this.received = true;
    },
  },
  getters: {
    getReceived: (state) => state.received,
    getTranscription: (state) => {
      // get last 5 final subtitles
      const finalSubtitles = state.finalSubtitles.slice(-5);
      let transcription = "";
      for (const subtitle of finalSubtitles) {
        transcription += `${subtitle}\n`;
      }
      if (state.partialSubtitles) {
        transcription += state.partialSubtitles;
      }
      return transcription.trim();
    },
    getPartialSubtitles: (state) => state.partialSubtitles || "",
    getFinalSubtitles: (state) => state.finalSubtitles,
    getChannelIsActive: (state) => (channelId) => state.activeChannels.includes(channelId),
  },
});
